export const Routes = {
  VRTCI: '/vrtec/',
  SOLE: '/sola/',
  BOLNISNICA: '/bolnisnica/',
  NOVICE: '/novice/',
  PROJEKTI: '/projekti/',
  OBRAZCI: '/obrazci/',
  KOLEDAR: '/koledar/',
  O_ZAVODU: '/zavod/',
}

export const __DEV__ = typeof window !== 'undefined'